import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { enviornment } from 'src/enviornments/enviornment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  url = enviornment.baseUrl;
  constructor(private http:HttpClient,private router:Router) { }

  setToken(token:string):void{
    localStorage.setItem('token',token);
    this.router.navigate(['/admin','dashboard']);
    // this.autoLogout();
  }

  setPrivileges(roles:string):void{
    localStorage.setItem('privileges',roles);
  }
  setUserId(id:any){
    localStorage.setItem('createdBy',id);
  }
  getToken():string | null{
    return localStorage.getItem('token');
  }

  isLoggedIn(){
    return this.getToken() !== null;
  }

  logout(){
    localStorage.removeItem('token');
    localStorage.removeItem('privileges');
    localStorage.removeItem('createdBy');
    this.router.navigate(['sign-in']);
  }

  autoLogout(){
    setTimeout(()=>{
      this.logout();
    }, 36000)
  }

  login(loginDetails:any){
    return this.http.post(this.url+'users/login',loginDetails);
  }
  forgotpassword(forgotPasswordForm:any){
    return this.http.post(this.url+'users/forgot-password',forgotPasswordForm);
  }
  resetPassword(token:any,newPassword:any){
    return this.http.post(this.url+`users/reset-password/${token}`, {newPassword: newPassword});
  }
}
